import React from 'react';
import { Typography } from '@progress/kendo-react-common';
import GearPage from './GearPage';
import { useUiAdminConfigsContext } from '../context/uiAdminConfigs/UiAdminConfigsContext';
import { GearHelpCenterState } from '../Model/GearHelpCenterState';
import { clientConfig } from '../config/clientConfig';
import { useGlobalizationContext } from '../context/globalization/GlobalizationContext';
import { useTranslation } from '../context/globalization/useTranslation';

export const AccessDeniedPage: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const { uiAdminConfigState } = useUiAdminConfigsContext();
  const {
    meta: { title: appName }
  } = clientConfig;
  const helpCenterAccessDeniedItem = (uiAdminConfigState.helpCenter as GearHelpCenterState)?.items?.find(
    item => item.openAccess
  );

  return (
    <GearPage className="gearPage--accessDenied">
      <Typography.h2>{translate('custom.accessDeniedPage.title')}</Typography.h2>
      <Typography.p>{translate('custom.accessDeniedPage.description', { appName })}</Typography.p>
      {helpCenterAccessDeniedItem && (
        <a href={helpCenterAccessDeniedItem.url} target="_blank" rel="noreferrer" className="accessDeniedManualLink">
          {helpCenterAccessDeniedItem.name}
        </a>
      )}
    </GearPage>
  );
};
